import { entityMap } from "./mappings";

export const groupIndustriesByTier = (industriesObj) => {
  const grouped = { Untiered: [], T1: [], T2: [], T3: [], T4: [], T5: [], Boosts: [], Other: [] };

  Object.entries(industriesObj).forEach(([key, value]) => {
    for (const [tier, ents] of Object.entries(entityMap)) {
      if (ents[key]) {
        // Check if it's a tree (based on name or key)
        if (ents[key].name === "Tree") {
          const existing = grouped[tier].find(e => e.name === "Tree");
          if (existing) {
            existing.count += value; // Sum the count
          } else {
            grouped[tier].push({
              key: "tree_grouped",
              count: value,
              ...ents[key],
            });
          }
        } else {
          grouped[tier].push({
            key,
            count: value,
            ...ents[key],
          });
        }
        return;
      }
    }
  });

  return grouped;
};
